import { ROLES as R } from "../core/roles";
import { lud, only, rule } from "../core/rule";

// Billing access (approved):
//  - ceo / cto / developer and dmm: billing administration;
//  - store / storeL: the client billing page for their own restaurants;
//  - ceo and cto only: "View as Store", a read-only preview of the client page;
//  - fa: the read-only accountant workspace in Billing and its sidebar entry, nothing else;
//  - every other role: no billing access at all.
// The billing API also returns capability flags (`access.canX`). They can only
// NARROW what these grants allow; they never grant anything on their own
// (see `billingAllows` in components/billing/billingAccess.js).
export const billingPermissions = {
  view: "billing.view",
  nav: "billing.nav",
  client: { view: "billing.client.view" },
  accountant: { view: "billing.accountant.view" },
  viewAsStore: "billing.viewAsStore",
  admin: {
    view: "billing.admin.view",
    invoiceIssue: "billing.admin.invoice.issue",
    fulfillmentManage: "billing.admin.fulfillment.manage",
    settingsManage: "billing.admin.settings.manage",
  },
  subscription: {
    create: "billing.subscription.create",
    change: "billing.subscription.change",
    cancel: "billing.subscription.cancel",
    grant: "billing.subscription.grant",
  },
};

// ceo, cto, developer and dmm administer billing (developer kept, NA-032).
const ADMINS = lud(R.DMM);
const BILLING_ROLES = lud(R.DMM, R.STORE, R.STORE_L, R.NEW);

export const billingGrants = {
  // the /auth/billing route and its sidebar entry
  "billing.view": rule(BILLING_ROLES),
  "billing.nav": rule([...BILLING_ROLES, R.FA]),
  // the accountant workspace: a second way into the route (routePolicies `or`), so `billing.view` and what it opens stay closed to fa
  "billing.accountant.view": rule(lud(R.DMM, R.FA)),
  // the restaurant's own billing page (restaurant scope is enforced by the API
  // through /me/restaurants)
  "billing.client.view": rule(only(R.STORE, R.STORE_L, R.NEW)),
  // read-only preview of the client page from the admin page
  "billing.viewAsStore": rule(only(R.CEO, R.CTO)),
  "billing.admin.view": rule(ADMINS),
  "billing.admin.invoice.issue": rule(ADMINS),
  "billing.admin.fulfillment.manage": rule(ADMINS),
  "billing.admin.settings.manage": rule(ADMINS),
  "billing.subscription.create": rule(ADMINS),
  "billing.subscription.change": rule(ADMINS),
  "billing.subscription.cancel": rule(ADMINS),
  // activate a subscription WITHOUT payment (and extend / convert / cancel such a grant): ceo, cto and developer only, never dmm
  "billing.subscription.grant": rule(lud()),
};
